export const PLACEHOLDER_WIDTH = "240px";
export const PLACEHOLDER_HEIGHT = "20px";
